import { SyntheticEvent } from 'react'
import { range } from 'remeda'
import { Form, Select } from 'semantic-ui-react'

const YearPicker = ({
  onChange,
  value,
}: {
  value: string
  onChange: (
    event: SyntheticEvent<HTMLElement, Event>,
    data: { value: string },
  ) => void
}) => {
  return (
    <Form.Field>
      <label>Year</label>
      <Select
        fluid
        search
        options={range(1970, 2022)
          .reverse()
          .map(y => ({
            key: y,
            value: y,
            text: y,
          }))}
        value={value}
        onChange={onChange}
        placeholder="Type or select year"
      />
    </Form.Field>
  )
}

export default YearPicker
